'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.PRACTICES = exports.SPECIALISTS = exports.HEALTH_CHECKS = exports.HEALTH_CHECK_TREATMENT_GROUPS = exports.SCAN_TREATMENT_GROUPS = exports.PROFESSIONAL_BODIES = exports.SPECIALTIES = exports.CONDITIONS = exports.PROCEDURES = exports.LANGUAGES = exports.INSURERS = undefined;

var _doctifyUtils = require('doctify-utils');

var INSURERS = exports.INSURERS = 'LISTINGS:INSURERS';
var LANGUAGES = exports.LANGUAGES = 'LISTINGS:LANGUAGES';
var PROCEDURES = exports.PROCEDURES = 'LISTINGS:PROCEDURES';
var CONDITIONS = exports.CONDITIONS = 'LISTINGS:CONDITIONS';
var SPECIALTIES = exports.SPECIALTIES = 'LISTINGS:SPECIALTIES';
var PROFESSIONAL_BODIES = exports.PROFESSIONAL_BODIES = 'LISTINGS:PROFESSIONAL_BODIES';
var SCAN_TREATMENT_GROUPS = exports.SCAN_TREATMENT_GROUPS = 'LISTINGS:SCAN_TREATMENT_GROUPS';
var HEALTH_CHECK_TREATMENT_GROUPS = exports.HEALTH_CHECK_TREATMENT_GROUPS = 'LISTINGS:HEALTH_CHECK_TREATMENT_GROUPS';
var HEALTH_CHECKS = exports.HEALTH_CHECKS = 'LISTINGS:HEALTH_CHECKS';
var SPECIALISTS = exports.SPECIALISTS = 'LISTINGS:SPECIALISTS';
var PRACTICES = exports.PRACTICES = 'LISTINGS:PRACTICES';

// Note the xhrConfig boilerplate. Might be nice to find a way to wrap this more nicely.
// TODO: Find a neater way than having EVERY function take an argument that is just passed on.
var ListingsActions = {
	getInsurers: function getInsurers(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'listings/insurers',
			method: 'GET',
			actionType: INSURERS,
			keyword: 'insurers',
			xhrConfig: xhrConfig
		});
	},
	getLanguages: function getLanguages(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'listings/languages',
			method: 'GET',
			actionType: LANGUAGES,
			keyword: 'languages',
			xhrConfig: xhrConfig
		});
	},
	getSpecialties: function getSpecialties(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'listings/specialties',
			method: 'GET',
			actionType: SPECIALTIES,
			keyword: 'keywords',
			xhrConfig: xhrConfig
		});
	},
	getConditions: function getConditions(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'keywords/condition',
			method: 'GET',
			actionType: CONDITIONS,
			keyword: 'keywords',
			xhrConfig: xhrConfig
		});
	},
	getProcedures: function getProcedures(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'keywords/procedure',
			method: 'GET',
			actionType: PROCEDURES,
			keyword: 'keywords',
			xhrConfig: xhrConfig
		});
	},
	getProfessionalBodies: function getProfessionalBodies(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'listings/professional_bodies',
			method: 'GET',
			actionType: PROFESSIONAL_BODIES,
			keyword: 'professional_bodies',
			xhrConfig: xhrConfig
		});
	},
	getTreatmentGroups: function getTreatmentGroups(type, xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'treatment_groups',
			parameters: { type: type },
			method: 'GET',
			actionType: type === 'scan' ? SCAN_TREATMENT_GROUPS : HEALTH_CHECK_TREATMENT_GROUPS,
			keyword: 'treatment_groups',
			xhrConfig: xhrConfig
		});
	},
	getHealthChecks: function getHealthChecks(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'keywords',
			parameters: { keyword_type: 'health_check' },
			method: 'GET',
			actionType: HEALTH_CHECKS,
			keyword: 'keywords',
			xhrConfig: xhrConfig
		});
	},
	getSpecialists: function getSpecialists(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'search',
			parameters: { page_limit: 5, sort_field: 'relevance', sortorder: 'asc', types_filter: '10' },
			method: 'GET',
			actionType: SPECIALISTS,
			xhrConfig: xhrConfig
		});
	},
	getPractices: function getPractices(xhrConfig) {
		return (0, _doctifyUtils.createAction)({
			url: 'search',
			parameters: { page_limit: 5, sort_field: 'relevance', sortorder: 'asc', types_filter: '01' },
			method: 'GET',
			actionType: PRACTICES,
			xhrConfig: xhrConfig
		});
	}
};

exports.default = ListingsActions;